import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../../src/api";
import { useUserAuth } from "../User/UserAuthContext/UserAuthContext";
import IndiaMapHome from "../../src/assests/IndiaMapHome.png";
import Logo2Home from "../../src/assests/Logo2-home.png";
import { Link } from "react-router-dom";
import HomeSlider from "../components/HomeSlider/HomeSlider";
import StickyVideoUp from "./StickyVideoUp";
import Popup from "./PopupDownload/Popup";
import clipImg from "../assests/VideouplodImg.jpg";
import "./Home2.css";

function Home2() {
  const { handleLogout, user } = useUserAuth();
  const [registeredCount, setRegisteredCount] = useState(0);
  const [scount, setScount] = useState(0);
  const navigate = useNavigate();
  const videoRef = useRef(null);
  const [isVideoVisible, setIsVideoVisible] = useState(false);

  // Players Registered Count API
  // useEffect(() => {
  //   fetch(`${BASE_URL}students/registered_count/`)
  //     .then((response) => response.json())
  //     .then((data) => {
  //       setRegisteredCount(data.data);
  //     })
  //     .catch((error) => console.log(error));
  // }, []);

  // Players to Next Level API
  // useEffect(() => {
  //   fetch(`${BASE_URL}students/selected_count/`)
  //     .then((response) => response.json())
  //     .then((data) => {
  //       setScount(data.data);
  //     })
  //     .catch((error) => console.log(error));
  // }, []);

  // Register Button Conditional Render
  const handleRegisterClick = () => {
    if (user) {
      navigate("/register-form");
    } else {
      navigate("/login");
    }
  };

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5, // 0.5 means when 50% of the element is visible
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setIsVideoVisible(true);
          entry.target.play();
        } else {
          setIsVideoVisible(false);
          entry.target.pause();
        }
      });
    }, options);

    if (videoRef.current) {
      observer.observe(videoRef.current);
    }

    return () => {
      if (videoRef.current) {
        observer.unobserve(videoRef.current);
      }
    };
  }, []);

  return (
    <>
      <div className="image-section2">
        <div className="HeroLeft">
          <HomeSlider />
          <div className="btnRegister">
            <h1 className="gradient-heading">Village to World Cup</h1>
            <button className="btn" onClick={handleRegisterClick}>
              {user ? "BOYS REGISTER NOW" : "LOGIN TO REGISTER"}
            </button>
          </div>
        </div>
      </div>
      <StickyVideoUp />
      <Popup />
      <div className="InstructionVideo">
        <div className="Instv-Image">
          <img src={clipImg} alt="" />
        </div>
        <div className="Instv-Video">
          <Link to="/isbc-intro">
            <i className="fa-sharp fa-regular fa-circle-play"></i>
          </Link>
        </div>
      </div>
      <div>
        <div className="IndiaMap">
          <div className="IndiaMapLeftSection">
            <img
              className="IndiaMap-Home"
              src={IndiaMapHome}
              alt="isbc india map"
            />
          </div>
          <div className="IndiaMapRightSection">
            <div className="Logo2-isbc">
              <img src={Logo2Home} alt="" />
            </div>
            <div className="RegisterdPlayers">
              <h1>Total Registrations</h1>
              {/* {registeredCount && (
                <p className="Students_Count">{registeredCount.count}</p>
              )} */}
            </div>
            <div className="SelectedPlayers">
              <h1>Players to next level</h1>
              {/* {scount && <p className="Students_Count">{scount.count}</p>} */}
            </div>
          </div>
        </div>
        <div className="video-home-container" style={{ zIndex: "-1" }}>
          <video
            className="video2345"
            src="https://d2ou8hgu4mxzkl.cloudfront.net/video/PhoneImage_4_1.mp4"
            autoPlay={isVideoVisible}
            controls
            ref={videoRef}
          />
          <audio src="https://d2ou8hgu4mxzkl.cloudfront.net/video/PhoneImage_4_1.mp4" />
        </div>
      </div>
    </>
  );
}

export default Home2;
